import request from '@/http/http'
const PREFIX = 'api/identity/positions';

// 树形数据
export function getPostAllTree(query) {
    return request({
        url: PREFIX + '/all-tree',
        params: query
    })
}

// 树形数据
export function getPostTree(query) {
    return request({
        url: PREFIX + '/tree',
        params: query
    })
}

// 非树形数据
export function getPostAll(query) {
    return request({
        url: PREFIX + '/all',
        params: query
    })
}

// 非树形数据
export function getPosts(query) {
    return request({
        url: PREFIX,
        params: query
    })
}

export function getPostInfo(id) {
    return request({
        url: PREFIX + '/' + id
    })
}

export function createPost(data) {
    return request({
        url: PREFIX,
        method: "post",
        data
    })
}

export function deletePost(id) {
    return request({
        url: PREFIX + "/" + id,
        method: 'delete'
    })
}

export function updatePost(id, data) {
    return request({
        url: PREFIX + '/' + id,
        method: 'put',
        data
    })
}

export function getPostRoles(id) {
    return request({
        url: PREFIX + '/' + id+'/roles'
    })
}

export function updatePostRoles(id, data) {
    return request({
        url: PREFIX + '/' + id+'/roles',
        method: 'put',
        data
    })
}